import {
	GetPlayerWithDepositPromotionRequest,
	GetPlayerWithDepositPromotionResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerWithDepositPromotion } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerWithDepositPromotion(
	payload: GetPlayerWithDepositPromotionRequest,
	props?: UseBaseQueryOptions<GetPlayerWithDepositPromotionResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerWithDepositPromotion, payload],
		queryFn: () => getPlayerWithDepositPromotion(payload),
		...props,
	})
}
